module.exports = __webpack_public_path__ + "static/img/4-2.b76a3c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/4-2.jpg
// module id = 6BRm
// module chunks = 0